import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../_metronic/helpers'
import {constants} from '../../../utils/const'
import {configuration} from '../../../configuration'

const API_URL = configuration.apiUrl
const CITY_WISE_REPORT =  `${API_URL}/city`
const Customer_Recalculate_URL = `${API_URL}/customer/recalculateLedger`
const RECALCULATE_URL = `${API_URL}/party/recalculateLedger`
const EDIT_NORMAL_ENTRY = `${API_URL}/message/editNormalEntry`
const recalculateLedger = (data: any): Promise<any> => {
  return axios
    .post(RECALCULATE_URL, data)
    .then((response: AxiosResponse<Response<any>>) => response)
}

const getCityWiseClosingReport = (): Promise<any> => {
  return axios.get(`${CITY_WISE_REPORT}/getCityWiseClosingReport`).then((d: AxiosResponse<any>) => d.data)
}

export const filterCityWiseClosingReport = (params: Record<string, any>): Promise<any> => {
  return axios
    .get(`${CITY_WISE_REPORT}/postFilterCityWiseClosingReport`, { params }) // Axios automatically converts params to query string
    .then((response: AxiosResponse<any>) => response.data);
};

export const editNormalEntry = (id: number, data: Record<string, any>): Promise<any> => {
  return axios
    .patch(`${EDIT_NORMAL_ENTRY}/message/editNormalEntry/${id}`, data)
    .then((response: AxiosResponse<any>) => response.data);
};


export {
  recalculateLedger,
  getCityWiseClosingReport
  // filterCityWiseClosingReport
}
